export default __webpack_public_path__ + "static/media/17.66d6afbb.jpeg";